<template>
    <div>
        <div class="stepper-container desktop-view" v-if="!rapd">
            <div class="stepper-group active">
                <div class="dash-group">
                    <div class="dash d-active"></div>
                    <div class="d-progress progress" style="--w:100%"></div>
                </div>
                <div class="dash-group-info"> <span class="active">
                        1
                    </span>
                    <p>{{ __('messages.traveler_information') }}</p>
                </div>
            </div>
            <div class="stepper-group">
                <div class="dash-group">
                    <div class="dash"></div>
                </div>
                <div class="dash-group-info"> <span>2</span>
                    <p>{{ __('messages.payment') }}</p>
                </div>
            </div>
        </div> <!-- STEPPER FINALIZA DESKTOP --> <!-- STEPPER INICIA DESKTOP RAPD -->
        <div class="stepper-container desktop-view" v-if="rapd">
            <div class="stepper-group active">
                <div class="dash-group">
                    <div class="dash d-active"></div>
                    <div class="d-progress progress" style="--w:100%"></div>
                </div>
                <div class="dash-group-info"> <span class="active">
                        <div class="stepper-circle"></div>
                    </span>
                    <p>{{ __('messages.traveler_information') }}</p>
                </div>
            </div>
            <!-- <div class="stepper-group"> <div class="dash-group"> <div class="dash"></div> </div> <div class="dash-group-info"> <span>2</span> <p>{{ __('messages.payment') }}</p> </div> </div> -->
        </div>
    </div>
</template>
<script>

const site = window.__pt.settings.site;
export default {

    props: ['step', 'rapd'],
    data() {
        return {
            data: {},
            steps: [],
            siteConfig: site
        };
    },
    async mounted() {
        this.initialize();
    },
    methods: {
        initialize() {
            let self = this;
            let position = 1;

            self.steps.push({
                position: position,
                title: self.__('messages.enter_your_data'),
                className: "icons-person",
                active: self.step == 1,
                done: self.step > 1
            });

            if (!self.rapd) {
                self.steps.push({
                    position: ++position,
                    title: self.__('messages.method_of_payment'),
                    className: "icons-credit-card-outline",
                    active: self.step == 2,
                    done: self.step > 2
                });
            }

            self.steps.push({
                position: ++position,
                title: self.__('messages.confirmation'),
                className: "icons-check-1",
                active: self.step == 3,
                done: self.step > 3
            });
        }
    },
    components: {
    }
}
</script>
